export enum RoundKind {
  /// <summary>
  /// روند به بالا
  /// </summary>
  Top = 1,
  /// <summary>
  /// روند به پایین
  /// </summary>
  Down = 2,
  /// <summary>
  /// روند نرمال
  /// </summary>
  Normal = 3,
}

export enum HrmReportPrintKind {
  /// <summary>
  /// گزارش ماه جاری
  /// </summary>
  BillPayWithOuteBackPay = 1,
  /// <summary>
  /// گزارش معوقه
  /// </summary>
  BillPayOnlyBackPay = 2,
  /// <summary>
  /// گزارش سرجمع
  /// </summary>
  BillPayAll = 3,
}
